import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const MoneyBackIcon = (props: SvgIconProps) => (
  <SvgIcon
    sx={{
      width: 27,
      height: 31,
    }}
    width="27"
    height="31"
    viewBox="0 0 27 31"
    fill={"none"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2702 4.35581L13.4431 2.01815L2.61604 4.35581V14.802C2.61604 20.7256 6.41143 25.9716 12.0084 27.7842L13.4431 28.2489L14.8778 27.7842C20.4748 25.9716 24.2702 20.7256 24.2702 14.802V4.35581ZM13.4431 30.1587L15.43 29.5152C21.7732 27.4609 26.0747 21.5154 26.0747 14.802V2.88596L13.4431 0.158691L0.811523 2.88596V14.802C0.811523 21.5154 5.11297 27.4609 11.4562 29.5152L13.4431 30.1587Z"
      fill="#000D8C"
    />
    <path
      d="M10.2078 13.4831L8.93183 14.7688L12.7598 18.6257L19.1397 12.1975L17.8637 10.9118L12.7598 16.0544L10.2078 13.4831Z"
      fill="#000D8C"
    />
  </SvgIcon>
);

export default MoneyBackIcon;
